'use strict';

Object.defineProperty(exports, "__esModule", {
		value: true
});

exports.default = function () {
		return function (value) {
				if (value instanceof Date) {
						var result = value;
				} else {
						var result = new Date(value);
				}

				var dd = result.getDate();
				var mm = result.getMonth() + 1;
				var yyyy = result.getFullYear();

				if (dd < 10) {
						dd = dd;
				}
				if (mm < 10) {
						mm = mm;
				}

				return dd + '/' + mm + '/' + yyyy;
		};
};


// WEBPACK FOOTER //
// ./client/components/filters/toDateString.js